var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.116,
    height: 41.971,
    viewBox: "0 0 42.116 41.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2039",
    "data-name": "Grupo 2039",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3375",
    "data-name": "Caminho 3375",
    d: "M1334.9,709.45l-4.918-2.655-3.254,4.546-3.414-4.425-4.82,2.828-1.319-5.431-5.554.624,1-5.5-5.328-1.69,3.152-4.614-4.18-3.71,4.759-2.934-2.311-5.089,5.54-.745-.04-5.588,5.364,1.573,2.237-5.122,4.26,3.618,4.127-3.768,2.419,5.037,5.3-1.764.162,5.587,5.562.545-2.124,5.169,4.86,2.76-4.043,3.859,3.317,4.5-5.263,1.879,1.2,5.459-5.574-.424Z",
    transform: "translate(-1306.27 -671.37)",
    fill: "none",
    stroke: "#fcdea4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3373",
    "data-name": "Caminho 3373",
    d: "M1443.594,808h1.932c1.364,0,1.684,1,1.458,2.228,0,0-.548,6.253-.732,6.873s-.548,1.528-1.464,1.528h-7.318c-2,0-2.12-1.932-3.539-1.932H1432",
    transform: "translate(-1416.815 -791.499)",
    fill: "none",
    stroke: "#df9b15",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3374",
    "data-name": "Caminho 3374",
    d: "M1436.73,769.529a3.578,3.578,0,0,0,3.571-2.785,6.557,6.557,0,0,1,.559-1.64,6.606,6.606,0,0,0,.382-.8,4.721,4.721,0,0,0,.426-2.079,2.8,2.8,0,0,0-.914-2.556c-.722-.618-1.83-.338-1.83.35v.732c0,1.54-1.135,1.952-2.3,3.1a4.31,4.31,0,0,1-2.7,1.351h-1.932",
    transform: "translate(-1416.806 -748.701)",
    fill: "none",
    stroke: "#df9b15",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1751",
    "data-name": "Ret\\xE2ngulo 1751",
    width: 4.831,
    height: 12.561,
    transform: "translate(10.354 14.569)",
    fill: "none",
    stroke: "#df9b15",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.10391054194d8748e3122e5a63cacbc0.svg";
export { ForwardRef as ReactComponent };